module.exports = __webpack_public_path__ + "img/bank.ca25a40a.png";